import { sendTrackingEvent } from '../services/service.tracking';

export const trackAppleWalletBadgeClick = () => {
  sendTrackingEvent({
    event: 'analytics_event',
    eventElement: 'ico-add-to-apple-wallet-button',
    eventAction: 'click',
    eventResult: 'cta::add-wallet-pass::apple',
    eventNonInteractive: false,
  });
};
